import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en/en.json'
import sk from './locales/sk/sk.json'
import hu from './locales/hu/hu.json'
import pl from './locales/pl/pl.json'
import de from './locales/de/de.json'
import ua from './locales/ua/ua.json'
import cs from './locales/cz/cz.json'
import fr from './locales/fr/fr.json'
import es from './locales/es/es.json'
import et from './locales/et/et.json'

import enTranslation from './locales/en/translation.json'
import skTranslation from './locales/sk/translation.json'
import huTranslation from './locales/hu/translation.json'
import plTranslation from './locales/pl/translation.json'
import deTranslation from './locales/de/translation.json'
import uaTranslation from './locales/ua/translation.json'
import csTranslation from './locales/cz/translation.json'
import frTranslation from './locales/fr/translation.json'
import esTranslation from './locales/es/translation.json'
import etTranslation from './locales/et/translation.json'

import enInfoGrid from './locales/en/infoGrid.json'
import skInfoGrid from './locales/sk/infoGrid.json'
import huInfoGrid from './locales/hu/infoGrid.json'
import plInfoGrid from './locales/pl/infoGrid.json'
import deInfoGrid from './locales/de/infoGrid.json'
import uaInfoGrid from './locales/ua/infoGrid.json'
import csInfoGrid from './locales/cz/infoGrid.json'
import frInfoGrid from './locales/fr/infoGrid.json'
import esInfoGrid from './locales/es/infoGrid.json'
import etInfoGrid from './locales/et/infoGrid.json'

import enMembership from './locales/en/membership.json'
import skMembership from './locales/sk/membership.json'
import huMembership from './locales/hu/membership.json'
import plMembership from './locales/pl/membership.json'
import deMembership from './locales/de/membership.json'
import uaMembership from './locales/ua/membership.json'
import csMembership from './locales/cz/membership.json'
import frMembership from './locales/fr/membership.json'
import esMembership from './locales/es/membership.json'
import etMembership from './locales/et/membership.json'

import enMembershipCatalog from './locales/en/membership_catalog.json'
import skMembershipCatalog from './locales/sk/membership_catalog.json'
import huMembershipCatalog from './locales/hu/membership_catalog.json'
import plMembershipCatalog from './locales/pl/membership_catalog.json'
import deMembershipCatalog from './locales/de/membership_catalog.json'
import uaMembershipCatalog from './locales/ua/membership_catalog.json'
import csMembershipCatalog from './locales/cz/membership_catalog.json'
import frMembershipCatalog from './locales/fr/membership_catalog.json'
import esMembershipCatalog from './locales/es/membership_catalog.json'
import etMembershipCatalog from './locales/et/membership_catalog.json'

import enDashboard from './locales/en/dashboard.json'
import skDashboard from './locales/sk/dashboard.json'
import huDashboard from './locales/hu/dashboard.json'
import plDashboard from './locales/pl/dashboard.json'
import deDashboard from './locales/de/dashboard.json'
import uaDashboard from './locales/ua/dashboard.json'
import csDashboard from './locales/cz/dashboard.json'
import frDashboard from './locales/fr/dashboard.json'
import esDashboard from './locales/es/dashboard.json'
import etDashboard from './locales/et/dashboard.json'

import enInfoPage from './locales/en/infopage.json'
import skInfoPage from './locales/sk/infopage.json'
import huInfoPage from './locales/hu/infopage.json'
import plInfoPage from './locales/pl/infopage.json'
import deInfoPage from './locales/de/infopage.json'
import uaInfoPage from './locales/ua/infopage.json'
import csInfoPage from './locales/cz/infopage.json'
import frInfoPage from './locales/fr/infopage.json'
import esInfoPage from './locales/es/infopage.json'
import etInfoPage from './locales/et/infopage.json'

import enVehicles from './locales/en/vehicles.json'
import skVehicles from './locales/sk/vehicles.json'
import huVehicles from './locales/hu/vehicles.json'
import plVehicles from './locales/pl/vehicles.json'
import deVehicles from './locales/de/vehicles.json'
import uaVehicles from './locales/ua/vehicles.json'
import csVehicles from './locales/cz/vehicles.json'
import frVehicles from './locales/fr/vehicles.json'
import esVehicles from './locales/es/vehicles.json'
import etVehicles from './locales/et/vehicles.json'

import enTriplog from './locales/en/triplog.json'
import skTriplog from './locales/sk/triplog.json'
import huTriplog from './locales/hu/triplog.json'
import plTriplog from './locales/pl/triplog.json'
import deTriplog from './locales/de/triplog.json'
import uaTriplog from './locales/ua/triplog.json'
import csTriplog from './locales/cz/triplog.json'
import frTriplog from './locales/fr/triplog.json'
import esTriplog from './locales/es/triplog.json'
import etTriplog from './locales/et/triplog.json'

import enCountries from './locales/en/countries.json'
import skCountries from './locales/sk/countries.json'
import huCountries from './locales/hu/countries.json'
import plCountries from './locales/pl/countries.json'
import deCountries from './locales/de/countries.json'
import uaCountries from './locales/ua/countries.json'
import csCountries from './locales/cz/countries.json'
import frCountries from './locales/fr/countries.json'
import esCountries from './locales/es/countries.json'
import etCountries from './locales/et/countries.json'

import enAdvertisement from './locales/en/advertisement.json'
import skAdvertisement from './locales/sk/advertisement.json'
import huAdvertisement from './locales/hu/advertisement.json'
import plAdvertisement from './locales/pl/advertisement.json'
import deAdvertisement from './locales/de/advertisement.json'
import uaAdvertisement from './locales/ua/advertisement.json'
import csAdvertisement from './locales/cz/advertisement.json'
import frAdvertisement from './locales/fr/advertisement.json'
import esAdvertisement from './locales/es/advertisement.json'
import etAdvertisement from './locales/et/advertisement.json'

import enAdvertisingTerms from './locales/en/advertisingTerms.json'
import skAdvertisingTerms from './locales/sk/advertisingTerms.json'
import huAdvertisingTerms from './locales/hu/advertisingTerms.json'
import plAdvertisingTerms from './locales/pl/advertisingTerms.json'
import deAdvertisingTerms from './locales/de/advertisingTerms.json'
import uaAdvertisingTerms from './locales/ua/advertisingTerms.json'
import csAdvertisingTerms from './locales/cz/advertisingTerms.json'
import frAdvertisingTerms from './locales/fr/advertisingTerms.json'
import esAdvertisingTerms from './locales/es/advertisingTerms.json'
import etAdvertisingTerms from './locales/et/advertisingTerms.json'

import enVop from './locales/en/vop.json'
import skVop from './locales/sk/vop.json'
import huVop from './locales/hu/vop.json'
import plVop from './locales/pl/vop.json'
import deVop from './locales/de/vop.json'
import uaVop from './locales/ua/vop.json'
import csVop from './locales/cz/vop.json'
import frVop from './locales/fr/vop.json'
import esVop from './locales/es/vop.json'
import etVop from './locales/et/vop.json'

import enGDPR from './locales/en/GDPR.json'
import skGDPR from './locales/sk/GDPR.json'
import huGDPR from './locales/hu/GDPR.json'
import plGDPR from './locales/pl/GDPR.json'
import deGDPR from './locales/de/GDPR.json'
import uaGDPR from './locales/ua/GDPR.json'
import csGDPR from './locales/cz/GDPR.json'
import frGDPR from './locales/fr/GDPR.json'
import esGDPR from './locales/es/GDPR.json'
import etGDPR from './locales/et/GDPR.json'

import enCookies from './locales/en/cookies.json'
import skCookies from './locales/sk/cookies.json'
import huCookies from './locales/hu/cookies.json'
import plCookies from './locales/pl/cookies.json'
import deCookies from './locales/de/cookies.json'
import uaCookies from './locales/ua/cookies.json'
import csCookies from './locales/cz/cookies.json'
import frCookies from './locales/fr/cookies.json'
import esCookies from './locales/es/cookies.json'
import etCookies from './locales/et/cookies.json'

import enLicenses from './locales/en/licenses.json'
import skLicenses from './locales/sk/licenses.json'
import huLicenses from './locales/hu/licenses.json'
import plLicenses from './locales/pl/licenses.json'
import deLicenses from './locales/de/licenses.json'
import uaLicenses from './locales/ua/licenses.json'
import csLicenses from './locales/cz/licenses.json'
import frLicenses from './locales/fr/licenses.json'
import esLicenses from './locales/es/licenses.json'
import etLicenses from './locales/et/licenses.json'

import enFeatures from './locales/en/features.json'
import skFeatures from './locales/sk/features.json'
import huFeatures from './locales/hu/features.json'
import plFeatures from './locales/pl/features.json'
import deFeatures from './locales/de/features.json'
import uaFeatures from './locales/ua/features.json'
import csFeatures from './locales/cz/features.json'
import frFeatures from './locales/fr/features.json'
import esFeatures from './locales/es/features.json'
import etFeatures from './locales/et/features.json'

import enRegAdvantage from './locales/en/reg_advantage.json'
import skRegAdvantage from './locales/sk/reg_advantage.json'
import huRegAdvantage from './locales/hu/reg_advantage.json'
import plRegAdvantage from './locales/pl/reg_advantage.json'
import deRegAdvantage from './locales/de/reg_advantage.json'
import uaRegAdvantage from './locales/ua/reg_advantage.json'
import csRegAdvantage from './locales/cz/reg_advantage.json'
import frRegAdvantage from './locales/fr/reg_advantage.json'
import esRegAdvantage from './locales/es/reg_advantage.json'
import etRegAdvantage from './locales/et/reg_advantage.json'

import enReferrInfo from './locales/en/referrInfo.json'
import skReferrInfo from './locales/sk/referrInfo.json'
import huReferrInfo from './locales/hu/referrInfo.json'
import plReferrInfo from './locales/pl/referrInfo.json'
import deReferrInfo from './locales/de/referrInfo.json'
import uaReferrInfo from './locales/ua/referrInfo.json'
import csReferrInfo from './locales/cz/referrInfo.json'
import frReferrInfo from './locales/fr/referrInfo.json'
import esReferrInfo from './locales/es/referrInfo.json'
import etReferrInfo from './locales/et/referrInfo.json'

const COUNTRY_TO_LANG = {
  SK: 'sk',
  CZ: 'cs',
  HU: 'hu',
  PL: 'pl',
  DE: 'de',
  AT: 'de',
  UA: 'ua',
  FR: 'fr',
  ES: 'es',
  EE: 'et'
}

const savedLang = localStorage.getItem('lang')

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          ...en,
          ...enTranslation,
          ...enInfoGrid,
          ...enMembership,
          ...enDashboard,
          ...enInfoPage,
          ...enVehicles,
          ...enTriplog,
          ...enCountries,
          ...enVop,
          ...enGDPR,
          ...enCookies,
          licenses: enLicenses
        },
        membership_catalog: enMembershipCatalog,
        advertisement: enAdvertisement,
        advertisingTerms: enAdvertisingTerms,
        features: enFeatures,
        regAdvantage: enRegAdvantage,
        referrInfo: enReferrInfo
      },

      sk: {
        translation: {
          ...sk,
          ...skTranslation,
          ...skInfoGrid,
          ...skMembership,
          ...skDashboard,
          ...skInfoPage,
          ...skVehicles,
          ...skTriplog,
          ...skCountries,
          ...skVop,
          ...skGDPR,
          ...skCookies,
          licenses: skLicenses
        },
        membership_catalog: skMembershipCatalog,
        advertisement: skAdvertisement,
        advertisingTerms: skAdvertisingTerms,
        features: skFeatures,
        regAdvantage: skRegAdvantage,
        referrInfo: skReferrInfo
      },

      hu: {
        translation: {
          ...hu,
          ...huTranslation,
          ...huInfoGrid,
          ...huMembership,
          ...huDashboard,
          ...huInfoPage,
          ...huVehicles,
          ...huTriplog,
          ...huCountries,
          ...huVop,
          ...huGDPR,
          ...huCookies,
          licenses: huLicenses
        },
        membership_catalog: huMembershipCatalog,
        advertisement: huAdvertisement,
        advertisingTerms: huAdvertisingTerms,
        features: huFeatures,
        regAdvantage: huRegAdvantage,
        referrInfo: huReferrInfo
      },

      pl: {
        translation: {
          ...pl,
          ...plTranslation,
          ...plInfoGrid,
          ...plMembership,
          ...plDashboard,
          ...plInfoPage,
          ...plVehicles,
          ...plTriplog,
          ...plCountries,
          ...plVop,
          ...plGDPR,
          ...plCookies,
          licenses: plLicenses
        },
        membership_catalog: plMembershipCatalog,
        advertisement: plAdvertisement,
        advertisingTerms: plAdvertisingTerms,
        features: plFeatures,
        regAdvantage: plRegAdvantage,
        referrInfo: plReferrInfo
      },

      de: {
        translation: {
          ...de,
          ...deTranslation,
          ...deInfoGrid,
          ...deMembership,
          ...deDashboard,
          ...deInfoPage,
          ...deVehicles,
          ...deTriplog,
          ...deCountries,
          ...deVop,
          ...deGDPR,
          ...deCookies,
          licenses: deLicenses
        },
        membership_catalog: deMembershipCatalog,
        advertisement: deAdvertisement,
        advertisingTerms: deAdvertisingTerms,
        features: deFeatures,
        regAdvantage: deRegAdvantage,
        referrInfo: deReferrInfo
      },

      ua: {
        translation: {
          ...ua,
          ...uaTranslation,
          ...uaInfoGrid,
          ...uaMembership,
          ...uaDashboard,
          ...uaInfoPage,
          ...uaVehicles,
          ...uaTriplog,
          ...uaCountries,
          ...uaVop,
          ...uaGDPR,
          ...uaCookies,
          licenses: uaLicenses
        },
        membership_catalog: uaMembershipCatalog,
        advertisement: uaAdvertisement,
        advertisingTerms: uaAdvertisingTerms,
        features: uaFeatures,
        regAdvantage: uaRegAdvantage,
        referrInfo: uaReferrInfo
      },

      cs: {
        translation: {
          ...cs,
          ...csTranslation,
          ...csInfoGrid,
          ...csMembership,
          ...csDashboard,
          ...csInfoPage,
          ...csVehicles,
          ...csTriplog,
          ...csCountries,
          ...csVop,
          ...csGDPR,
          ...csCookies,
          licenses: csLicenses
        },
        membership_catalog: csMembershipCatalog,
        advertisement: csAdvertisement,
        advertisingTerms: csAdvertisingTerms,
        features: csFeatures,
        regAdvantage: csRegAdvantage,
        referrInfo: csReferrInfo
      },

      fr: {
        translation: {
          ...fr,
          ...frTranslation,
          ...frInfoGrid,
          ...frMembership,
          ...frDashboard,
          ...frInfoPage,
          ...frVehicles,
          ...frTriplog,
          ...frCountries,
          ...frVop,
          ...frGDPR,
          ...frCookies,
          licenses: frLicenses
        },
        membership_catalog: frMembershipCatalog,
        advertisement: frAdvertisement,
        advertisingTerms: frAdvertisingTerms,
        features: frFeatures,
        regAdvantage: frRegAdvantage,
        referrInfo: frReferrInfo
      },

      es: {
        translation: {
          ...es,
          ...esTranslation,
          ...esInfoGrid,
          ...esMembership,
          ...esDashboard,
          ...esInfoPage,
          ...esVehicles,
          ...esTriplog,
          ...esCountries,
          ...esVop,
          ...esGDPR,
          ...esCookies,
          licenses: esLicenses
        },
        membership_catalog: esMembershipCatalog,
        advertisement: esAdvertisement,
        advertisingTerms: esAdvertisingTerms,
        features: esFeatures,
        regAdvantage: esRegAdvantage,
        referrInfo: esReferrInfo
      },

      et: {
        translation: {
          ...et,
          ...etTranslation,
          ...etInfoGrid,
          ...etMembership,
          ...etDashboard,
          ...etInfoPage,
          ...etVehicles,
          ...etTriplog,
          ...etCountries,
          ...etVop,
          ...etGDPR,
          ...etCookies,
          licenses: etLicenses
        },
        membership_catalog: etMembershipCatalog,
        advertisement: etAdvertisement,
        advertisingTerms: etAdvertisingTerms,
        features: etFeatures,
        regAdvantage: etRegAdvantage,
        referrInfo: etReferrInfo
      }
    },

    lng: savedLang || 'en',
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false
    }
  })

if (!savedLang) {
  fetch('/api/country')
    .then(res => res.json())
    .then(({ country }) => {
      const detectedLang = COUNTRY_TO_LANG[country] || 'en'

      i18n.changeLanguage(detectedLang)
    })
    .catch(() => {
      i18n.changeLanguage('en')
    })
}

export default i18n